module.exports = __webpack_public_path__ + "assets/img/age.79c031eb.png";